module.exports = __webpack_public_path__ + "img/find_talent.c5eae1a.jpg";